/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedDatasetDatasourceListResponse } from '../types/PaginatedDatasetDatasourceList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type DatasetsDatasourcesListRequest = {} | null | undefined;
export type DatasetsDatasourcesListResponse = PaginatedDatasetDatasourceListResponse;

export type DatasetsDatasourcesListQuery = {
  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;
};

/**
 * GET /dmx-server/datasets_datasources/
 *
 * ```yaml
 * operationId: datasets_datasources_list
 * tags:
 *   - datasets_datasources
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedDatasetDatasourceList'
 *     description: ''
 * ```
 */
export const datasetsDatasourcesListOperation = (rest?: DatasetsDatasourcesListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/datasets_datasources/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/datasets_datasources/' };
  };

/**
 * GET /dmx-server/datasets_datasources/
 *
 * ```yaml
 * operationId: datasets_datasources_list
 * tags:
 *   - datasets_datasources
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedDatasetDatasourceList'
 *     description: ''
 * ```
 */
export const datasetsDatasourcesList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: DatasetsDatasourcesListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedDatasetDatasourceListResponse>> => {
  const operation = datasetsDatasourcesListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/datasets_datasources/
 */
export const useDatasetsDatasourcesListResource = (
  query: DatasetsDatasourcesListQuery | null,
  useCached?: boolean,
): UseResource<DatasetsDatasourcesListResponse> => {
  return useResource<DatasetsDatasourcesListResponse>({
    path: query === null ? null : datasetsDatasourcesListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
